import { IMargin, IPadding } from 'src/interfaces/global';
import NGTable from 'src/styles/theme/components/NGTable';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { addMarginStyles, addPaddingStyles, mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledTableRichText = styled.div<IMargin & IPadding>`
	${(p) => css`
		width: calc(100% - 12px);

		border: 1px solid ${p.theme.colors.gold + '80'};

		border-radius: 3px;

		flex-shrink: 0;

		overflow-x: auto;

		${addMarginStyles(p)}
		${addPaddingStyles(p)}
	`}
`;

export const NGTableEx = styled(NGTable)`
	flex-shrink: 0;

	width: 100%;

	${mq(EMediaQuery.md, `width: fit-content; min-width: 100%;`)}
`;
